import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { AlarmLimits } from "../../../actions/apiActions";
import LinearGauge from "./linearGauge/LinearGauge";

const getValueColor = (category, isAlarmActive) => {
  if ((category === "SampleCondition" || category === "Device") && isAlarmActive) return "error.main";
  if (category === "Warning" && isAlarmActive) return "warning.main";
  return "text.primary";
};

const ModuleItem = ({ displayName = "", valueName, value = "", valueTimestamp = "", unit = "", category, isAlarmActive, solutionType = "", tag = "", showDeviceTags, showLinearGauges, dataIsRecent = false, hwId, config }) => {
  const [linearGaugeValues, setLinearGaugeValues] = useState({});
  const showMore = showDeviceTags || showLinearGauges || solutionType === "lora";

  useEffect(() => {
    const fetchAlarmLimits = async () => {
      try {
        const params = {
          HwId: hwId,
          ValueName: valueName,
          CustomerId: config.CUSTOMER_ID,
          DeviceId: config.DEVICE_ID,
          isLoraDevice: solutionType === "lora",
        };
        if (!params.ValueName) return;
        const response = await AlarmLimits.get(config.DATA_URL, params);
        if (Object.keys(response.limits).length > 2) {
          setLinearGaugeValues(response);
        }
      } catch {
        // alarm limits fetch failed
      }
    };
    if (showLinearGauges) fetchAlarmLimits();
  }, [showLinearGauges]);

  if (!displayName) return null;

  const color = getValueColor(category, isAlarmActive);

  return (
    <Box>
      <Box sx={{ display: "flex", py: 1, pl: 1, pr: 3, alignItems: "center", gap: 1 }}>
        <Typography variant="h6" color={color} noWrap sx={{ flex: 1, minWidth: 0 }}>
          {displayName}
        </Typography>
        <Typography variant="h6" color={color} sx={{ flexShrink: 0 }}>
          {dataIsRecent ? `${value}  ${unit}` : "-"}
        </Typography>
      </Box>
      {showMore && (
        <Grid container>
          <Grid size={{ md: 12, lg: 6 }} sx={{ ml: 1 }}>
            {showDeviceTags && solutionType !== "lora" && (
              <Typography variant="caption" sx={{ color: "text.secondary" }}>{tag}</Typography>
            )}
            {solutionType === "lora" && (
              <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.7rem" }}>{valueTimestamp}</Typography>
            )}
          </Grid>
          <Grid size={{ md: 12, lg: 6 }} sx={{ position: "relative" }}>
            {showLinearGauges && linearGaugeValues.limits && (
              <LinearGauge linearGaugeValues={linearGaugeValues.limits} deviceValue={value} displayName={displayName} />
            )}
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ModuleItem;
